export const CITY_IDS_FOR_ADDITIONAL_SPLIT: number[] = [
  217, 976, 315, 272, 382, 269, 244, 280, 285, 809, 1086, 745, 136, 730, 914, 748,
];
